var _defs, _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRtc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "contents",
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs4"
  }, /*#__PURE__*/React.createElement("style", {
    id: "style2"
  }, ".cls-1{fill:lime;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title6"
  }, "\u30A2\u30FC\u30C8\u30DC\u30FC\u30C9 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title6"
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 75,
    height: 75,
    rx: 11.338583,
    id: "rect8",
    x: 0,
    y: 0,
    ry: 11.338583
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.08,36.69H39.37v-9.8a2.67,2.67,0,1,0-5.34,0V39.36A2.67,2.67,0,0,0,36.7,42h9.38a2.67,2.67,0,0,0,0-5.34Z",
    id: "path10"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5,10.78A26.72,26.72,0,0,0,10.78,37.5c0,.73,0,1.44.09,2.16h6.59a19.41,19.41,0,0,1-.12-2.16,20.15,20.15,0,1,1,9.19,16.92l3.28-3.6a.94.94,0,0,0-.53-1.56l-15.52-2.7H13.6a1,1,0,0,0-.91,1.18L16.79,63a.93.93,0,0,0,.69.66.78.78,0,0,0,.22,0,.93.93,0,0,0,.69-.31l3.67-4A26.72,26.72,0,1,0,37.5,10.78Z",
    id: "path12"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRtc);
export default __webpack_public_path__ + "static/media/RTC.e862dda95936b6ee8ca232468dd5b24c.svg";
export { ForwardRef as ReactComponent };